import { devtools } from "./v2/v2";

export default devtools;
